import '../../../assets/login.css';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/UI/Input/Input';
import { useHistory } from 'react-router-dom';
import Select from '../../../components/UI/Select/Select';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import { auth } from '../../../firebase-init';
import './style.css';
import { useEffect } from 'react';
import Radio from '../../../components/UI/Radio/Radio';
const PersonalInformation = () => {
  const { t, i18n } = useTranslation();

  const { submitHandler, field, loading, establishments } = useForm();
  let history = useHistory();

  useEffect(() => {
    auth.onIdTokenChanged(async function (user) {
      console.log('PersonalInformation User');
      console.log(user);
      if (!user) {
        history.push('/login');
      }
    });
  }, []);
  useEffect(() => {
    console.log({level: field('level')})
  }, [field])
  const logout = () => {
    auth.signOut();
  };
  return (
    <div className="container-fluid login-banner">
      <div className="row d-flex justify-content-center ">
        <div className="col-lg-5  col-10 registration-card personal-information-container">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="login-card-title ">{t('personal-information.form.title')}</h2>
              </div>

              <div className="col-12">
                <form>
                  <div className="row pr-3 pl-3">
                    <div className="col-md-6 form-group ">
                      <label htmlFor="firstname" className="font-weight-bold">
                        {t('personal-information.form.nom')}
                      </label>
                      <Input
                        type="text"
                        className="form-control pt-2 pb-2"
                        aria-describedby="firstname"
                        placeholder={t('personal-information.form.placeholderNom')}
                        {...field('firstName')}
                      />
                    </div>

                    <div className="col-md-6 form-group ">
                      <label htmlFor="lastname" className="font-weight-bold">
                        {t('personal-information.form.lastName')}
                      </label>
                      <Input
                        type="text"
                        className="form-control  pt-2 pb-2"
                        aria-describedby="lastname"
                        placeholder={t('personal-information.form.placeholderLastName')}
                        {...field('lastName')}
                      />
                    </div>
                  </div>

                  <div className="col-12   form-group  mt-3">
                    <label className=" font-weight-bold mb-2">{t('personal-information.form.gender')}</label>
                    <br />
                  </div>
                  <div className=" d-flex justify-content-start gap-3">
                    <div className=''>
                      <Radio
                        className="form-check-Input"
                        type="radio"
                        id="male"
                        {...field('gender', 'radio', 'M')}
                        label={t('personal-information.form.male')}
                      />
                    </div>

                    <div className="">
                      <Radio
                        className="form-check-Input"
                        type="radio"
                        id="female"
                        {...field('gender', 'radio', 'F')}
                        label={t('personal-information.form.female')}
                      />
                    </div>
                  </div>
                  <div className="col-12 form-group mt-3">
                    <label htmlFor="bac_matricule" className="font-weight-bold">
                      {t('personal-information.form.matricule-bac')}
                    </label>
                    <Input
                      type="text"
                      className="form-control pt-2 pb-2"
                      id="bac_matricule"
                      aria-describedby="bac_matricule"
                      placeholder={t('personal-information.form.placeholderPhone')}
                      {...field('bac_matricule')}
                    />
                  </div>
                  <div className="col-12 form-group mt-3">
                    <label htmlFor="phone" className="font-weight-bold">
                      {t('personal-information.form.phone')}
                    </label>
                    <Input
                      type="phone"
                      className="form-control pt-2 pb-2"
                      id="phone"
                      aria-describedby="phone"
                      placeholder={t('personal-information.form.placeholderPhone')}
                      {...field('phone')}
                    />
                  </div>



                  <div className=" col-12 form-group ">
                    <label htmlFor="level" className="font-weight-bold mt-3">
                      {t('personal-information.form.level')}
                    </label>
                    <Select className="form-control pt-2 pb-2" id="level" {...field('level')}>
                      <option value="" disabled selected>
                        {t('personal-information.form.chooselevel')}
                      </option>
                      <optgroup label={t('system-LMD')}>
                        <option value="lmd-licence1">{t('personal-information.form.lmd-licence1')}</option>
                        <option value="lmd-licence2">{t('personal-information.form.lmd-licence2')}</option>
                        <option value="lmd-licence3">{t('personal-information.form.lmd-licence3')}</option>
                        <option value="lmd-master1">{t('personal-information.form.lmd-master1')}</option>
                        <option value="lmd-master2">{t('personal-information.form.lmd-master2')}</option>
                      </optgroup>
                      <optgroup label={t('system-classic-1')}>
                        <option value="classic-1-ingeniorat1">{t('personal-information.form.classic-1-ingeniorat1')}</option>
                        <option value="classic-1-ingeniorat2">{t('personal-information.form.classic-1-ingeniorat2')}</option>
                        <option value="classic-1-ingeniorat3">{t('personal-information.form.classic-1-ingeniorat3')}</option>
                        <option value="classic-1-ingeniorat4">{t('personal-information.form.classic-1-ingeniorat4')}</option>
                        <option value="classic-1-ingeniorat5">{t('personal-information.form.classic-1-ingeniorat5')}</option>
                      </optgroup>
                      <optgroup label={t('system-classic-2')}>
                        <option value="classic-2-licence1">{t('personal-information.form.classic-2-licence1')}</option>
                        <option value="classic-2-licence2">{t('personal-information.form.classic-2-licence2')}</option>
                        <option value="classic-2-licence3">{t('personal-information.form.classic-2-licence3')}</option>
                        <option value="classic-2-licence4">{t('personal-information.form.classic-2-licence4')}</option>
                        <option value="classic-2-magister1">{t('personal-information.form.classic-2-magister1')}</option>
                        <option value="classic-2-magister2">{t('personal-information.form.classic-2-magister2')}</option>
                      </optgroup>
                      <optgroup label={t('other')}>
                        <option value="other-class-preparatoire">
                          {t('personal-information.form.other-class-preparatoire')}
                        </option>
                        <option value="other-class-medecine">{t('personal-information.form.other-class-medecine')}</option>
                        <option value="other-class-teacher">{t('personal-information.form.other-class-teacher')}</option>
                        <option value="phd">{t('personal-information.form.phd')}</option>
                      </optgroup>
                    </Select>
                  </div>

                  <div className=" col-12 form-group mt-3">
                    <label htmlFor="etablishment" className="font-weight-bold mb-2">
                      {t('personal-information.form.establishment')}
                    </label>
                    <div>
                      <AutoComplete
                        placeholder={t('personal-information.form.placeholderEstablishment')}
                        label={''}
                        {...field('establishment', 'autoComplete')}
                        data={establishments}
                        valueObject="id"
                        titleObject="name"
                      />
                    </div>
                  </div>
                  <div className="personal-information-buttons-container">
                    <button
                      className="btn btn-warning  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                      type="submit"
                      disabled={loading}
                      onClick={submitHandler}
                      style={{ fontSize: '20px', marginTop: '20px' }}
                    >
                      <span
                        className="spinner-border "
                        role="status"
                        aria-hidden="true"
                        style={{ display: loading === true ? 'block' : 'none' }}
                      ></span>
                      <span className=""> {t('personal-information.form.confirm')}</span>
                    </button>
                    &nbsp; &nbsp;
                    <button
                      className="btn btn-secondary  btn-block btn-lg font-weight-bold d-flex justify-content-center "
                      type="button"
                      disabled={loading}
                      onClick={logout}
                      style={{ fontSize: '20px', marginTop: '20px' }}
                    >
                      <span
                        className="spinner-border "
                        role="status"
                        aria-hidden="true"
                        style={{ display: loading === true ? 'block' : 'none' }}
                      ></span>
                      <span className=""> {t('personal-information.form.cancel')}</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
